<template>
  <base-auth>
    <form @submit.prevent="onSubmitVerify" class="kt-form">
        <vue-recaptcha
            v-if="captchaDriver === 'recaptcha'"
            ref="invisibleRecaptchaVerify"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="sitekey"
            :loadRecaptchaScript="true">
        </vue-recaptcha>
        
        <arcaptcha-vue
            v-if="captchaDriver === 'arcaptcha'"
            ref="arcaptchaVerify"
            :site_key="arCaptchaKey"
            :invisible="true"
            :callback="onArcaptchaSuccess"
            :expired_callback="onArcaptchaExpired"
            :error_callback="onArcaptchaError"
        />
        
      <div class="login-form">
        <div class="kt-login__form" id="message_div"></div>
        <div class="form-field form-field-register" style="direction: rtl">
          <!--                <img src="@/assets/img/icon1.png" style="padding-bottom: 15px">-->
          <div id="phone-error" class="mb-3" style=" font-size: 90%;">
            {{ $t('auth.login.verify_label') }}
          </div>
          <input
              v-bind:placeholder="$t('auth.placeholder.phone')"
              name="phone"
              id="phone"
              v-model="form_data.phone"
              v-bind:disabled="sent?true:false"
              type="text"
          >
        </div>
        <div v-if="!sent" style="text-align: center" class="mt-5">
          <button id="send_verify" class="btn btn-success btn-pill px-5 py-3" @click="sendVerify">{{ $t('btn.send_code') }}</button>
        </div>
        <div v-if="sent">
          <div class="form-field form-field-register" style="direction: rtl">
            <!--                <img src="@/assets/img/icon1.png" style="padding-bottom: 15px">-->
            <input
                :placeholder="$t('auth.placeholder.code')"
                name="code"
                v-model="code"
                type="text"
            >
          </div>

          <div class="login-footer">
            <input
                type="submit"
                id="verify_submit"
                :value="$t('auth.btn.verify')"
            >
            <div class="kt-login__account" v-if="counter==false">
                    <span class="kt-login__account-msg">
                        {{ $t('auth.not_recived') }}
                    </span>&nbsp;&nbsp;
              <button class="btn btn-link p-0 m-0" id="resend_btn" @click="sendVerify">
                {{ $t('auth.btn.resend') }}
              </button>
            </div>
            <div class="kt-login__account" v-if="counter==true">
                    <span class="kt-login__account-msg">
                      <span class="bg-white p-0 m-0">
                        {{ $t('auth.code_not_received') }}
                      </span>
                      {{ message2 }}
                    </span>
            </div>
          </div>

        </div>
      </div>

    </form>
  </base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth'
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {mapGetters, mapState, mapActions} from "vuex";
import { reCaptchaKeys } from '@/constants/getRecaptchaKey';
import { arCaptchaKeys } from '@/constants/getArCaptchaKey'
import { getCaptchaDriver } from '@/constants/getCaptchaDriver'
import VueRecaptcha from "vue-recaptcha";
import ArcaptchaVue from 'arcaptcha-vue'

export default {
  data() {
    return {
      code: '',
      //  sent: false,
      timer: 60,
      message2: "",
      counter: false,
      interval: null,
        recaptcha_verified: false,
        g_recaptcha_response: "",
        sitekey: reCaptchaKeys,
        arCaptchaKey: arCaptchaKeys,
        captchaDriver: getCaptchaDriver,
        arcaptchaToken: '',
        arcaptchaVerified: false,
    }
  },
  computed: {
    ...mapState('auth', ['sent']),
    ...mapGetters('auth', [
      'form_data'
    ]),
    ...mapActions('auth', ['sendVerifyStatus']),
  },
  components: {
    'base-auth': baseAuth,
      VueRecaptcha,
      ArcaptchaVue
  },
  mounted() {
    setTimeout( () => {
      $('#send_verify').click();
    }, 1000);
  },
  methods: {
      onSubmitVerify: function (e) {
          this.login_event = e;
          this.executeCaptcha();
      },

      executeCaptcha() {
          if (this.captchaDriver === 'recaptcha') {
              this.$refs.invisibleRecaptchaVerify.execute();
          } else if (this.captchaDriver === 'arcaptcha') {
              this.arcaptchaVerified = false;
              this.arcaptchaToken = '';
              this.$refs.arcaptchaVerify.execute();
          } else if (!this.captchaDriver || this.captchaDriver === 'none') {
              this.verify(this.login_event);
          }
      },
      
      onVerify(response) {
          this.recaptcha_verified = true;
          this.g_recaptcha_response = response;
          this.verify(this.login_event);
      },
      
      onArcaptchaSuccess(token) {
          this.arcaptchaToken = token;
          this.arcaptchaVerified = true;
          this.verify(this.login_event);
      },
      
      onArcaptchaExpired() {
          this.arcaptchaVerified = false;
          this.arcaptchaToken = '';
      },
      
      onArcaptchaError(error) {
          this.arcaptchaVerified = false;
          this.arcaptchaToken = '';
      },
      
      onExpired() {
          this.recaptcha_verified = false;
      },
      
      resetCaptcha() {
          if (this.captchaDriver === 'recaptcha') {
              this.$refs.invisibleRecaptchaVerify.reset();
          } else if (this.captchaDriver === 'arcaptcha') {
              console.log(this.$refs.arcaptchaVerify.resetCaptcha());
              this.$refs.arcaptchaVerify.reset();
              this.arcaptchaVerified = false;
              this.arcaptchaToken = '';
          }
      },
      
    verify(e) {
      let form = $(e.target)
      let btn = $('#verify_submit')
      let phone = $('#phone')

      form.validate({
        rules: {
          code: {
            required: true
          },
          phone: {
            required: true,
          }
        }
      })

      if (!form.valid()) {
        return
      }

      let params = {
        code: this.code,
        phone: phone.val(),
      }

      if (this.captchaDriver === 'recaptcha') {
          params['g-recaptcha-response'] = this.g_recaptcha_response;
      } else if (this.captchaDriver === 'arcaptcha') {
          params['g-recaptcha-response'] = this.arcaptchaToken;
      }

      KTApp.progress(btn)

      setTimeout(function () {
        // this.sendVerifyStatus
        //this.sent = true;
      }.bind(this), 2000)

      this.$store.dispatch('auth/verifyRegister', params)
          .then(() => {
            window.location.replace(this.$url(''))
          })
          .catch(response => {
              this.resetCaptcha()
            if (response.data) {
              form.validate().showErrors(response.data)
            }

            this.showMsg(form, 'danger', response.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })
    },

    sendVerify(e) {
      let btn = $(e.target)
      let form = $('.kt-form')
      let phone = $('#phone')

      let params = {
        phone: phone.val(),
      }


      KTApp.progress(btn)
      this.$store.dispatch('auth/sendVerifyRegister', params)
          .then(response => {
            this.showMsg($('.kt-form'), 'success', response.message)
            this.sendVerifyStatus
            this.startTimer()
            // this.sent = true
          })
          .catch(response => {
            if (response.data) {
              form.validate().showErrors(response.data)
            }
            this.showMsg($('.kt-form'), 'danger', response.message)
          })
          .finally(() => {
            KTApp.unprogress(btn)
          })


    },
    startTimer() {
      this.interval = setInterval(this.countDown, 1000);
    },
    countDown() {
      var n = this.timer
      if (!this.counter) {
        this.counter = true;
      } else if (n > 0) {
        n = n - 1
        this.timer = n
        this.message2 = "ارسال مجدد کد در " + n + "ثانیه"
      } else {
        clearInterval(this.interval);
        this.counter = false
        this.message2 = ""
      }
    },
  }
}
</script>

<style scoped>
.btn.btn-link:hover, .btn.btn-link:focus {
  background-color: inherit !important;
  color: inherit !important;
}

.kt-login__account {
  direction: rtl !important;
}
</style>